import styled from 'styled-components';
import { CardSubscription as Card } from '../../../../components/CardSubscription';
import { TextInfo } from '../../../../components/TextInfo';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 4px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
`;

export const ContainerWarnings = styled.div`
  margin: 32px 0;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
`;

export const Info = styled(TextInfo)`
  align-items: flex-start;

  padding: 16px;
  border-radius: ${radius.md};
  border: 1px solid ${colors.outlineVariant}40;
  background-color: ${colors.surfaceContainerLow};

  span {
    text-align: left;
    line-height: 1.5;
  }
`;

export const ContainerSubscriptions = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;

  gap: 20px;

  @media (max-width: 1199px) {
    flex-direction: column;

    & > div {
      width: auto;
    }
  }
`;

export const CardSubscription = styled(Card)``;
